import {
  Component,
  ElementRef,
  HostListener,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { BuyerAuthService } from '../../../buyer-authentication/services/buyer-auth/buyer-auth.service';
import { AuthService } from 'src/app/Core/auth/services/auth/auth.service';
import { filter, Subscription } from 'rxjs';
import { StorageService } from 'src/app/Core/_services/storage/storage.service';
import { DefulatRouting } from 'src/app/_utlis/enums/defualt-routing.enum';
import { ProfileService } from 'src/app/app-modules/buyer/buyer-modules/buyer-profile/_services/profile.service';
import { environment } from 'src/environments/environment';
import { LocaleService } from 'src/app/Shared/services/locale/locale.service';

import {
  NavigationEnd,
  Router,
  RouterLink,
  RouterLinkActive,
} from '@angular/router';
import { PreviousRouteService } from 'src/app/Shared/services/previous-route/previous-route.service';
import { NotificationService } from 'src/app/app-modules/buyer/buyer-modules/account/notification/services/notification.service';
import { INotification } from 'src/app/Shared/_models/notification.interace';
import { HeaderComponent } from '../../../../../../Shared/components/header/header.component';
import { ClockComponent } from '../../../../../../Shared/components/clock/clock.component';
import { NgStyle } from '@angular/common';
import { LogoComponent } from '../../../../../../Shared/components/logo/logo.component';
import { ReactiveFormsModule } from '@angular/forms';
import { BuyerHeaderNotificationComponent } from '../buyer-header-notification/buyer-header-notification.component';
import { MatDivider } from '@angular/material/divider';
import { isPlatformBrowser } from '@angular/common';
import { Navigation } from 'src/app/_utlis/navigateToLanding';
import { DropdownComponent } from 'src/app/Shared/components/dropdown/dropdown.component';
import { HeaderSearchInputComponent } from '../header-search-input/header-search-input.component';
import { LanguageSwitcherComponent } from '../../../../../../Shared/components/language-switcher/language-switcher.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LocaleLinkPipe } from 'src/app/Shared/_pipes/locale-link/locale-link.pipe';

@Component({
    selector: 'app-buyer-header',
        standalone: true,
templateUrl: './buyer-new-header.component.html',
    styleUrls: ['./buyer-new-header.component.scss'],
    imports: [
    RouterLink,
    LogoComponent,
    ReactiveFormsModule,
    RouterLinkActive,
    HeaderSearchInputComponent,
    LanguageSwitcherComponent,
    TranslateModule,
    LocaleLinkPipe
]
})
export class BuyerHeaderComponent implements OnInit, OnDestroy {
  DefualtPath = environment.wordpressUrl;
  isLoggedIn = false;
  showNotification: boolean = false;
  notificationRecived!: boolean;

  // Store subscriptions for cleanup
  private subscriptions: Subscription[] = [];

  @Input() isSellerLoggedIn!: boolean;
  @Input() isBuyer!: boolean;
  @ViewChild('not', { static: false }) not!: ElementRef;
  @ViewChild('mainMenu', { static: false }) mainMenu!: ElementRef;
  @ViewChild('toggleButton', { static: false }) toggleButton!: ElementRef;

  @HostListener('document:click', ['$event.target']) onClick(event: Event) {
    if (this.not) {
      const parent = this.not.nativeElement;

      if (!parent.contains(event)) {
        this.showNotification = false;
      }
    }
  }
  offersDropdownItems = [
    { label: 'buyer_header.offers', route: '/buyer/account/my-offers' },
    { label: 'buyer_header.history', route: '/buyer/account/offers-history' },
  ];
  profile_img!: string;
  // buyerDefualtPath = DefulatRouting.BUYER;
  buyerDefualtPath = environment.wordpressUrl;
  horseOwnerPortalUrl = environment.horseOwnerPortalUrl;
  openMenu = false;
  isBrowser: boolean;

  isDev: boolean = environment.isDev;
  constructor(
    private auth: BuyerAuthService,
    private generalAuth: AuthService,
    private notService: NotificationService,
    private storage: StorageService,
    private profileService: ProfileService,
    private translate: TranslateService,
    @Inject(PLATFORM_ID) private platformId: any,
    private nav: Navigation,
    public router: Router,
    private elementRef: ElementRef
  ) {
    this.subscriptions.push(
      this.profileService.userDataChanged$.subscribe((res) => {
        this.profile_img = this.storage?.userData?.profile_picture;
      })
    );
    this.subscriptions.push(
      this.notService.notification$.subscribe((res) => {
        if (res) {
          this.notificationRecived = true;
        }
      })
    );
    this.isBrowser = isPlatformBrowser(this.platformId);
  }
  ngOnInit(): void {
    this.subscriptions.push(
      this.auth.loggedIn_authorized$.subscribe((res) => {
        this.isLoggedIn = res;
        if (this.isLoggedIn) {
          this.checkIfUnReadNot();
        }
      })
    );
    this.subscriptions.push(
      this.router.events
        .pipe(filter((event) => event instanceof NavigationEnd))
        .subscribe(() => {
          this.closeMobileMenu();
        })
    );
  }
  handleClickOutside = (event: Event): void => {
    const clickedInsideMenu = this.mainMenu?.nativeElement.contains(
      event.target
    );
    const clickedToggleButton = this.toggleButton?.nativeElement.contains(
      event.target
    );

    if (!clickedInsideMenu && !clickedToggleButton) {
      this.closeMobileMenu();
    }
  };
  checkIfUnReadNot() {
    this.notService.getNotifications(1, 4).subscribe((res) => {
      this.notificationRecived = res.data.items.some(
        (el: INotification) => el.read_at == null
      );
    });
  }
  closeMobileMenu(): void {
    this.openMenu = false;
    if (this.isBrowser) {
      document.removeEventListener('click', this.handleClickOutside, true);
    }
  }

  navgateToLandingPage() {
    this.openMenu = false;
    this.nav.NavigateToLanding();
  }

  toggleShowNot() {
    if (!this.showNotification) {
      this.notificationRecived = false;
    }
    this.showNotification = !this.showNotification;
  }
  toggleMenu(): void {
    this.openMenu = !this.openMenu;

    // Delay adding the document listener until after current event finishes
    if (this.isBrowser) {
      if (this.openMenu) {
        setTimeout(() => {
          document.addEventListener('click', this.handleClickOutside, true);
        });
      } else {
        document.removeEventListener('click', this.handleClickOutside, true);
      }
    }
  }
  logout() {
    this.generalAuth.logout();
    this.closeMobileMenu();
    // this.auth.setLoggedIn_authorized(false);
  }
  toggleNavigateToNotification() {
    this.notificationRecived = false;

    const notificationRoute = '/buyer/account/notification';

    if (location.href.includes(notificationRoute)) {
      if (this.isBrowser) {
        window.history.back();
      }
    } else {
      this.router.navigate([notificationRoute]);
    }
  }

  isHomeRoute(): boolean {
    const pathOnly = this.router.url.split(/[?#]/)[0] || '';
    return (
      pathOnly === '/en' ||
      pathOnly === '/en/' ||
      pathOnly === '/ar' ||
      pathOnly === '/ar/' ||
      pathOnly === '/'
    );
  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this.subscriptions.forEach(sub => sub.unsubscribe());
    this.subscriptions = [];

    // Remove document event listener if menu was open (SSR-safe)
    if (this.isBrowser) {
      document.removeEventListener('click', this.handleClickOutside, true);
    }
  }
}
